import { useStore } from '../../../store';

const store = useStore();

export const showMoreCheckout = (res) => {
    if (res > store.state.press.pageNumber) {
        store.commit('press/SET_PAGE_NUMBER', store.state.press.pageNumber + 1);
        store.commit('press/SET_BUTTON', true);
        store.commit('press/SET_SEARCH_ERROR', false);
    }
    else {
        store.commit('press/SET_BUTTON', false);
    }
}
